<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6a4DHA/tc-custom/9781423655367.jpg?1737683345880" alt="This image is the cover for the book Let's Brunch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Let's Brunch
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Puts a Southern twist on brunch . . . [An] enticing lineup of both sophisticated and down-home fare.” —<i>Publishers Weekly</i></b><br/>  <br/> Let Chef Belinda spice up your brunch menu with her warm hospitality, cooking tips, and flavor-packed recipes for breakfast and brunch.<br/>  <br/> A meal designed for leisure and good times spent with family and friends, brunch is the perfect setting for Belinda Smith-Sullivan’s curated flavors and hospitality. Smith-Sullivan grew up at her grandmother’s elbow, learning how to cook from scratch long before she had any professional training. This down-home connection to food is the base for her more sophisticated ingredient and spice combinations.<br/>  <br/> Now Chef Belinda offers up some of her tastiest dishes yet with brunch menu ideas like Red Velvet Pecan Waffles and Fried Chicken, or Collard Green and Rice Casserole served with Honey and Pepper Bacon, a side of Ramp Biscuits smeared with Meyer Lemon Marmalade, and a Pomegranate Mimosa to toast a great start to the day.<br/>  <br/> With more than one hundred satisfying recipes, this cookbook covers starters, soups, and salads; eggs dishes; pastas and casseroles; main courses and breakfast meats; grits; sandwiches; breads; jams and syrups; desserts; and brunch cocktails.<br/>  <br/> “Stellar recipes . . . Savory or sweet mild or spicy, vegetarian or omnivore, there’s a great dish awaiting every palate and pleasure.” —James Beard Award winner Cynthia Graubart</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Belinda Smith-Sullivan
      </h2>
      
      <p class="authorDescription body article"><B>Belinda Smith-Sullivan</B> is a chef, food writer, spice blends entrepreneur, and a commercially rated pilot. She has a culinary arts degree from Johnson &amp; Wales University, and writes a monthly column for both <I>South Carolina Living</I> and <I>Bella Magazine</I>. She also is featured on <I>South Carolina Living&#39;</I>s website with monthly how-to videos. Smith-Sullivan is an active member of the Southern Foodways Alliance, International Association of Culinary Professionals, American Culinary Federation, and Les Dames d&#39;Escoffier. She lives in Trenton, SC, in the heart of South Carolina&#39;s peach country.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ea47924